import React from 'react';
import TypingRankingPage from '../SubPages/TypingRankingPage';

const PortalTypingAllRecordsPage = () => <TypingRankingPage />;

export default PortalTypingAllRecordsPage;
